/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DetachRemoteSessionClientKeySetSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DetachRemoteSessionClientKeySetSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DetachRemoteSessionClientKeySetSecurity = {
  option1?: DetachRemoteSessionClientKeySetSecurityOption1 | undefined;
  option2?: DetachRemoteSessionClientKeySetSecurityOption2 | undefined;
};

export type DetachRemoteSessionClientKeySetRequest = {
  /**
   * The remote_session_client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DetachRemoteSessionClientKeySetSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DetachRemoteSessionClientKeySetSecurityOption1$outboundSchema:
  z.ZodMiniType<
    DetachRemoteSessionClientKeySetSecurityOption1$Outbound,
    DetachRemoteSessionClientKeySetSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function detachRemoteSessionClientKeySetSecurityOption1ToJSON(
  detachRemoteSessionClientKeySetSecurityOption1:
    DetachRemoteSessionClientKeySetSecurityOption1,
): string {
  return JSON.stringify(
    DetachRemoteSessionClientKeySetSecurityOption1$outboundSchema.parse(
      detachRemoteSessionClientKeySetSecurityOption1,
    ),
  );
}

/** @internal */
export type DetachRemoteSessionClientKeySetSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DetachRemoteSessionClientKeySetSecurityOption2$outboundSchema:
  z.ZodMiniType<
    DetachRemoteSessionClientKeySetSecurityOption2$Outbound,
    DetachRemoteSessionClientKeySetSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function detachRemoteSessionClientKeySetSecurityOption2ToJSON(
  detachRemoteSessionClientKeySetSecurityOption2:
    DetachRemoteSessionClientKeySetSecurityOption2,
): string {
  return JSON.stringify(
    DetachRemoteSessionClientKeySetSecurityOption2$outboundSchema.parse(
      detachRemoteSessionClientKeySetSecurityOption2,
    ),
  );
}

/** @internal */
export type DetachRemoteSessionClientKeySetSecurity$Outbound = {
  Option1?: DetachRemoteSessionClientKeySetSecurityOption1$Outbound | undefined;
  Option2?: DetachRemoteSessionClientKeySetSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DetachRemoteSessionClientKeySetSecurity$outboundSchema:
  z.ZodMiniType<
    DetachRemoteSessionClientKeySetSecurity$Outbound,
    DetachRemoteSessionClientKeySetSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        DetachRemoteSessionClientKeySetSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        DetachRemoteSessionClientKeySetSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function detachRemoteSessionClientKeySetSecurityToJSON(
  detachRemoteSessionClientKeySetSecurity:
    DetachRemoteSessionClientKeySetSecurity,
): string {
  return JSON.stringify(
    DetachRemoteSessionClientKeySetSecurity$outboundSchema.parse(
      detachRemoteSessionClientKeySetSecurity,
    ),
  );
}

/** @internal */
export type DetachRemoteSessionClientKeySetRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DetachRemoteSessionClientKeySetRequest$outboundSchema:
  z.ZodMiniType<
    DetachRemoteSessionClientKeySetRequest$Outbound,
    DetachRemoteSessionClientKeySetRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
      });
    }),
  );

export function detachRemoteSessionClientKeySetRequestToJSON(
  detachRemoteSessionClientKeySetRequest:
    DetachRemoteSessionClientKeySetRequest,
): string {
  return JSON.stringify(
    DetachRemoteSessionClientKeySetRequest$outboundSchema.parse(
      detachRemoteSessionClientKeySetRequest,
    ),
  );
}
